import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { DEFAULT_MENU, type MenuConfig } from "@/lib/menuConfig";

export const useMenuConfig = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["menu-config"],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data } = await supabase.from("menu_config").select("config").eq("id", "sidebar").maybeSingle();
      const cfg = data?.config as unknown as MenuConfig | undefined;
      return cfg?.sections?.length ? cfg : DEFAULT_MENU;
    },
  });
  return { config: data ?? DEFAULT_MENU, isLoading };
};

export const useSaveMenuConfig = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (config: MenuConfig | null) => {
      if (config === null) {
        const { error } = await supabase.from("menu_config").delete().eq("id", "sidebar");
        if (error) throw error;
        return;
      }
      const { data: u } = await supabase.auth.getUser();
      const { error } = await supabase.from("menu_config").upsert({
        id: "sidebar", config: config as never, updated_at: new Date().toISOString(), updated_by: u.user?.id ?? null,
      });
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["menu-config"] }),
  });
};
